import { render, staticRenderFns } from "./tb_user_overview.vue?vue&type=template&id=7b097bbe&scoped=true"
import script from "./tb_user_overview.vue?vue&type=script&lang=js"
export * from "./tb_user_overview.vue?vue&type=script&lang=js"
import style0 from "./tb_user_overview.vue?vue&type=style&index=0&id=7b097bbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b097bbe",
  null
  
)

export default component.exports